import { useState } from 'react';
import { faqs } from '@/mocks/gossip';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100/70">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-10 px-4 py-16 md:px-6 lg:grid-cols-[0.85fr_1.15fr]">
        <div>
          <p className="flex items-center gap-2 text-sm font-medium text-primary-500">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
            FAQ
          </p>
          <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-foreground-950">
            常见问题
          </h2>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
            关于内容来源、投稿方式与信息纠错，这里汇集了读者最常问的问题。如果仍没解决你的疑惑，欢迎通过投稿表单告诉我们。
          </p>
          <a
            href="#contact"
            className="mt-6 inline-flex items-center gap-2 rounded-md border border-foreground-950 px-5 py-2.5 text-sm font-medium text-foreground-900 transition-colors hover:bg-foreground-950 hover:text-background-50"
          >
            仍有疑问，找我聊聊
            <i className="ri-question-line" />
          </a>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? 'border-primary-200' : 'border-background-200'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-start gap-3">
                    <span className={`mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded text-xs font-bold ${isOpen ? 'bg-primary-500 text-white' : 'bg-secondary-100 text-secondary-700'}`}>
                      {i + 1}
                    </span>
                    <span className="font-heading text-base font-bold leading-snug text-foreground-900">
                      {f.q}
                    </span>
                  </span>
                  <i
                    className={`ri-add-line shrink-0 text-xl transition-transform duration-300 ${
                      isOpen ? 'rotate-45 text-primary-500' : 'text-foreground-400'
                    }`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-[52px] text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}